import PropTypes from 'prop-types';

/**
 * Stands in for an assigned admin the admin list does not carry — organization
 * -service's mirror can lag auth-service. Shown rather than dropped, so the row
 * and the edit dialog never hide an assignment a Save would keep.
 */
export const UNKNOWN_ADMIN_LABEL = 'Unknown admin';

/** One row of the table, as `useSalesMetrosPage` builds it (`ISalesMetroRow`). */
export const salesMetroRowPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  assignedInternalUserIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  admins: PropTypes.arrayOf(
    PropTypes.shape({
      internalUserId: PropTypes.string.isRequired,
      name: PropTypes.string,
    }),
  ).isRequired,
});
